import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { AssociatedContentItems, AssociatedContentItemsErrors } from '../types';
import AddNewContent from './AddNewContent';
import ContentItemError from './ContentItemError';
import LearnMore from './LearnMore';
import RemoveContentItem from './RemoveContentItem';

const PostEventAssociatedContent = ({
  associatedContentItems,
  associatedContentItemsErrors = [],
  event = {},
  currentSessionId,
  sessions,
}) => {
  const hasContentError = (contentItem, errors) => {
    return errors.find(
      error => error.associationId === contentItem.association_id,
    );
  };

  const content =
    sessions && sessions.length === 1
      ? associatedContentItems
      : associatedContentItems.filter(
          /*eslint-disable eqeqeq */
          item => item.session_id == currentSessionId,
        );

  return (
    <>
      <div className="mb-16 PostEventAssociatedContent">
        <div>
          <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
            {t('in_person_training.event_content.follow_up_content')}
          </Text>
        </div>
        <Text variant={TEXT_VARIANTS.BODY}>
          {t('in_person_training.event_content.assign_follow_up_lessons')}
          <span className="ml-4">
            <LearnMore />
          </span>
        </Text>
      </div>
      {!event.is_archived && (
        <AddNewContent currentSessionId={currentSessionId} />
      )}
      {!!content.length && (
        <>
          <div className="py-16 border-bottom border-midnight-20">
            <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
              {t('in_person_training.event_content.title').toUpperCase()}
            </Text>
          </div>
          <div>
            {content.map(contentItem => (
              <div
                className="py-16 border-bottom border-midnight-20"
                key={contentItem.association_id}
              >
                <div className=" d-f jc-sb fd-r">
                  <Text variant={TEXT_VARIANTS.BODY_LINK}>
                    <a
                      className="p-0 text-wrap"
                      href={contentItem.overview_url}
                    >
                      {contentItem.title}
                    </a>
                  </Text>
                  {!event.is_archived && (
                    <RemoveContentItem contentItem={contentItem} />
                  )}
                </div>
                {!!contentItem.archived_at && (
                  <ContentItemError
                    message={t('in_person_training.errors.archived_content')}
                  />
                )}
                {!!associatedContentItemsErrors.length &&
                  hasContentError(
                    contentItem,
                    associatedContentItemsErrors,
                  ) && <ContentItemError />}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
};

PostEventAssociatedContent.propTypes = {
  associatedContentItems: AssociatedContentItems,
  associatedContentItemsErrors: AssociatedContentItemsErrors,
};

export default PostEventAssociatedContent;
